import React, { useCallback, useEffect, useState } from 'react';
import './Home.css';
import up from './floral_transparent_up.png'
import down from './floral_transparent_down.png'
import hor from './floral_horizontal_straight.png'
import left from './partial_left.png'
import right from './partial_right.png'



function Home() {
  const viewportWidth: number = window.innerWidth || 400;

   const CountdownTimer = ({ targetDate }: { targetDate: string }) => {

    const calculateTimeLeft = useCallback(() => {
      const difference = +new Date(targetDate) - +new Date();
      let timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };

      if (difference > 0) {
        timeLeft = {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        };
      }

      return timeLeft;
    }, [targetDate]); 

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);

      return () => clearInterval(timer);
    }, [calculateTimeLeft]);

    return (
      <div className="countdown">
        <div className="timer">
          <span>{timeLeft.days} gg</span> :
          <span>{timeLeft.hours} hh</span> :
          <span>{timeLeft.minutes} mm</span> :
          <span>{timeLeft.seconds} ss</span>
        </div>
      </div>
    );
  };

  return (
    <div className="app">
      {viewportWidth > 440 ? 
      <header className="header flowers-desk">
         <img src={up} className='flowers' alt=""/>
        <h1>Fabrizio e Giulia</h1>
        <img src={down} className='flowers' alt=""/>
      </header>
      :
      <header className="header flowers-mobile">
         <img src={up} className='flower' alt=""/>
        <h1>Fabrizio <br/> e <br/> Giulia</h1>
        <img src={down} className='flowers' alt=""/>
      </header>
      }
      <div className='content'>
        <div className='section-intro'>
          <section className="intro">
            <h2>Cari amici e familiari</h2>
            <p>Quest'autunno si terrà un evento molto speciale: il nostro matrimonio!</p>
            <p>Non possiamo immaginare questo giorno senza le persone che ci sono più vicine e vogliamo che sia un giorno speciale per tutti.</p>
            <p>In attesa del grande giorno, abbiamo creato questo sito, dove potrete trovare una serie di informazioni utili.</p>
          </section>
        </div>

        <div className='section-when'>
          <section className="intro">
          <div className='title-flower'>
            <img src={left} width={'16%'} alt=""/> <h2>Quando</h2> <img src={right} width={'16%'} alt=""/>
          </div>
            <p>L'evento si terrà sabato 11 ottobre 2025 alle ore 17.00 e stiamo già facendo il conto alla rovescia!</p>
          </section>
          <CountdownTimer targetDate="2025-10-11T17:00:00+02:00" />
        </div>

        <div className='section-where'>
          <section className="intro">
            <div className='title-flower'>
              <img src={left} width={'16%'} alt=""/> <h2>Dove</h2> <img src={right} width={'16%'} alt=""/>
            </div>
            <p>Tutti i momenti più emozionanti della giornata, dalla cerimonia al ricevimento, si terranno nella stessa suggestiva cornice di Corte Noa a Pula, di cui vi lasciamo qui sotto la posizione.</p>
            <div className='iframe-dim'>
              <iframe title="mappa" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3101.389288819585!2d8.977905076633851!3d38.98361087170574!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12e727cdfdff89a3%3A0x5e7a638f05fec585!2sCorte%20Noa!5e0!3m2!1sit!2sit!4v1749463465187!5m2!1sit!2sit" width="95%" height="280" loading="lazy"></iframe>
            </div>
          </section>
        </div>
      
      <div className='section-2'>
        <section className="dress-code">
          <div className='title-flower'>
            <img src={left} width={'16%'} alt=""/> <h3>Dress code</h3> <img src={right} width={'16%'} alt=""/>
          </div>
          <p>Parole d'ordine: sorrisi, voglia di festeggiare ed eleganza. Indossate ciò che vi fa sentire splendidi e pronti a vivere una giornata speciale con noi. Sentitevi liberi di brillare, restando sempre voi stessi.</p>
        </section>
        <section className="organization">
          <div className='title-flower'>
            <img src={left} width={'16%'} alt=""/> <h3>Conferma la tua presenza</h3> <img src={right} width={'16%'} alt=""/>
          </div>
          <p>Per noi è molto importante avere conferma della vostra presenza entro venerdì 5 Settembre 2025. <br/>
          <p>Per farlo, inviaci un messaggio, sottolineando anche eventuali allergie e intolleranze alimentari:</p><br/>
          Fabrizio: <strong>+39 392 8755 818</strong><br/>
          Giulia: <strong>+39 349 0855 514</strong><br/>
          </p>
        </section>
        <section className="organization">
            <div className='title-flower'>
            <img src={left} width={'16%'} alt=""/> <h3>Organizzazione</h3> <img src={right} width={'16%'} alt=""/>
          </div>
          <p>Ti piacerebbe condividere una storia sugli sposi? Se voleste raccontare qualcosa su di noi durante la cerimonia potete contattare i nostri celebranti:<br/><br/>
          Paolo: <strong>+39 348 226 6284</strong><br/>
          Alessia: <strong>+39 333 323 4970</strong><br/>
          </p>
        </section>
        <section className="organization">
            <div className='title-flower'>
            <img src={left} width={'16%'} alt=""/> <h3>Il viaggio del cuore</h3> <img src={right} width={'16%'} alt=""/>
          </div>
          <p>Chi ci conosce bene sa che il nostro sogno nel cassetto da un po' di tempo è visitare il Giappone. Se anche voi volete aiutarci a realizzarlo, lasciamo qui sotto l'IBAN:<br/><br/>
          Beneficiario: <strong>Fabrizio Moro</strong> o <strong>Giulia Pisano</strong><br/>
          IBAN: <strong>IT36E0306904861100000065638</strong><br/>
          </p>
        </section>
      </div>
      </div>
      <footer className="footer">
        <div className='title-flower'>
          <img src={left} width={'16%'} alt=""/> <p style={{marginTop: '35px'}}>Speriamo ci sarete</p> <img src={right} width={'16%'} alt=""/>
        </div>
        <h4>Vostri, <br/> Fabrizio e Giulia</h4>
      </footer>
      <img src={hor} className='flowers' alt=""/>
    </div>
  );
}

export default Home;
